const ExchangeLocations = () => {
  const locations = [
    {
      name: 'Banco Azteca Centro',
      type: 'Bank',
      address: 'Av. Juárez 123, Centro Histórico',
      rate: 18.65,
      fees: '$0 USD',
      hours: 'Mon-Fri: 9AM-5PM, Sat: 9AM-2PM',
      rating: 4.8,
      features: ['No fees', 'Secure', 'ATM available']
    },
    {
      name: 'Casa de Cambio El Dólar',
      type: 'Exchange House',
      address: 'Calle 16 de Septiembre 456',
      rate: 18.78,
      fees: '$2 USD',
      hours: 'Mon-Sat: 8AM-8PM, Sun: 10AM-6PM',
      rating: 4.6,
      features: ['Best rates', 'Fast service', 'Extended hours']
    },
    {
      name: 'Intercam Casa de Cambio',
      type: 'Exchange House',
      address: 'Av. Lincoln 789, Zona Pronaf',
      rate: 18.72,
      fees: '$1.50 USD',
      hours: 'Mon-Fri: 8AM-7PM, Sat: 9AM-4PM',
      rating: 4.7,
      features: ['Tourist friendly', 'English spoken', 'Wire transfers']
    },
    {
      name: 'BBVA Bancomer Plaza Las Misiones',
      type: 'Bank',
      address: 'Blvd. Tomás Fernández 2345',
      rate: 18.60,
      fees: '$0 USD',
      hours: 'Mon-Fri: 8:30AM-4:30PM',
      rating: 4.5,
      features: ['No fees for amounts >$100', 'ATM network', 'Debit cards accepted']
    },
    {
      name: 'Money Exchange Plaza de Armas',
      type: 'Exchange House',
      address: 'Plaza de Armas, Local 12',
      rate: 18.80,
      fees: '$3 USD',
      hours: 'Daily: 9AM-9PM',
      rating: 4.4,
      features: ['Central location', 'Tourist area', 'Multiple currencies']
    },
    {
      name: 'Cambios Fronterizos',
      type: 'Exchange House',
      address: 'Av. de las Américas 567',
      rate: 18.75,
      fees: '$1 USD',
      hours: 'Mon-Sat: 7AM-9PM, Sun: 9AM-7PM',
      rating: 4.9,
      features: ['Highest rated', 'Border specialists', '24/7 emergency service']
    }
  ];

  return (
    <div className="mt-20">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-zinc-900 mb-4">Best Exchange Locations in Juárez</h2>
        <p className="text-xl text-zinc-600 max-w-2xl mx-auto">
          Find trusted currency exchange locations with competitive rates and excellent service
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-8">
        {locations.map((location, index) => (
          <div key={index} className="bg-white rounded-2xl p-8 border border-zinc-200 shadow-lg hover:shadow-xl transition-all">
            <div className="flex items-start justify-between mb-6">
              <div>
                <h3 className="text-xl font-bold text-zinc-900 mb-2">{location.name}</h3>
                <div className="flex items-center gap-2 mb-2">
                  <span className={`px-3 py-1 rounded-full text-sm font-semibold ${
                    location.type === 'Bank' 
                      ? 'bg-blue-100 text-blue-700' 
                      : 'bg-emerald-100 text-emerald-700'
                  }`}>
                    {location.type}
                  </span>
                  <div className="flex items-center gap-1">
                    {[...Array(5)].map((_, i) => (
                      <i 
                        key={i} 
                        className={`ri-star-fill text-sm ${
                          i < Math.floor(location.rating) ? 'text-yellow-400' : 'text-zinc-300'
                        }`}
                      ></i>
                    ))}
                    <span className="text-sm text-zinc-600 ml-1">{location.rating}</span>
                  </div>
                </div>
                <p className="text-zinc-600 mb-1">
                  <i className="ri-map-pin-line text-emerald-500 mr-2"></i>
                  {location.address}
                </p>
                <p className="text-zinc-600">
                  <i className="ri-time-line text-emerald-500 mr-2"></i>
                  {location.hours}
                </p>
              </div>
              <div className="text-right">
                <div className="text-2xl font-bold text-emerald-600 mb-1">
                  {location.rate}
                </div>
                <div className="text-sm text-zinc-500 mb-2">per USD</div>
                <div className="text-sm text-zinc-600">
                  Fee: {location.fees}
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-2 mb-6">
              {location.features.map((feature, featureIndex) => (
                <span 
                  key={featureIndex}
                  className="px-3 py-1 bg-zinc-100 text-zinc-700 rounded-full text-sm"
                >
                  {feature}
                </span>
              ))}
            </div>

            <div className="flex gap-3">
              <button className="flex-1 bg-emerald-500 text-white py-3 px-6 rounded-xl font-semibold hover:bg-emerald-600 transition-all whitespace-nowrap">
                Get Directions
              </button>
              <button className="px-6 py-3 border border-emerald-500 text-emerald-600 rounded-xl font-semibold hover:bg-emerald-50 transition-all whitespace-nowrap">
                Call Now
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Location Map */}
      <div className="mt-16 bg-white rounded-2xl p-8 border border-zinc-200 shadow-lg">
        <h3 className="text-2xl font-bold text-zinc-900 mb-6 text-center">Exchange Locations Map</h3>
        <div className="relative h-96 bg-zinc-100 rounded-xl overflow-hidden">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14201.567890123456!2d-106.4890616!3d31.7618778!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86e75d90e99d597b%3A0x6cd3524a6bd44086!2sCiudad%20Ju%C3%A1rez%2C%20Chihuahua%2C%20Mexico!5e0!3m2!1sen!2sus!4v1234567890123"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Currency Exchange Locations in Ciudad Juárez"
          ></iframe>
        </div>
        <p className="text-center text-zinc-600 mt-4">
          Interactive map showing all recommended currency exchange locations in Ciudad Juárez
        </p>
      </div>
    </div>
  );
};

export default ExchangeLocations;